{
  "Description": "VC : CCNNNNN",
  "RedundantCharacters": " -",
  "ValidationRegex": "^(VC)?[0-9]{4}$",
  "TestData": {
    "Valid": [
      "1234",
      "VC1234",
	  "VC-1234"
    ],
    "Invalid": [
      "VC123",
      "V1234",
	  "VC-12345"
    ]
  }
}